<nav class="navbar navbar-expand-lg navbar-dark bg-secondary mb-3 shadow p-3">
    <div class="container">
        <a class="navbar-brand" [routerLink]="linkRaces">Crew House</a>
<!--
        <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
            &#9776;
        </button>

        <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="linkRaces" routerLinkActive="active" (click)="isMenuCollapsed = true">Races</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="linkEvents" routerLinkActive="active" (click)="isMenuCollapsed = true">Events</a>
                </li>
            </ul>
        </div>
-->
        <div class="d-flex">
            <app-authentication></app-authentication>
        </div>
    </div>
  </nav>